<!--
    @修改人：黎柏祺
    @修改时间：2018-11-28
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @负责人: 谢汉
    @创建时间: 2018-01-18
    @版本:v1.0.12
    @描述: 全屏组件
    @使用方法:
        <full-screen :wrapper-id="wrapperId" @get="getScreen"></full-screen>
        components: {
            'fullScreen': require('../../components/fullScreen.vue')
        },
        data() {
            return {
                wrapperId: 'domId'
            }
        },
        methods: {
            getScreen(...data) {
                //获取到绑定dom的宽高
            }
        }
    @参数说明:
    wrapperId： 需要全屏的dom ID
    -->
<style>
    .full-screen {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 6;
        cursor: pointer;
        width: 30px;
        height: 30px;
    }
    .chart-position {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 11;
    }
    .auto-scroll {
        overflow: auto;
    }
    .full-screen .icon {
        font-size: 30px;
        color: #999;
    }
    .full-screen .icon:hover {
        color: #0B8DE5;
    }
</style>
<template>
    <div>
        <div class="full-screen" @click="full" @mouseenter="enter" @mouseleave="leave">
            <i class="icon iconfont" :class="iconClass" :title="imgTitle" v-show="showIcon"></i>
        </div>
    </div>
</template>
<script>
const ICON_FULL_SCREEN = 'icon-zhankai'
const ICON_EXIT_FULL_SCREEN = 'icon-shouqi'

export default {
  data () {
    return {
      iconClass: ICON_FULL_SCREEN,
      showIcon: true,
      isFull: false,
      imgTitle: '',
      timer: null,
      isEnter: false,
      mouseDirection: {
        x: '',
        y: ''
      }
    }
  },
  methods: {
    enter () {
      if (this.isFull) {
        this.isEnter = true
        this.clearTimer()
      }
    },
    leave () {
      if (this.isFull) {
        this.isEnter = false
        this.clearTimer()
        this.setTimer()
      }
    },
    sendSize () {
      if (this.isFull) {
        this.doubleChart === 1 ? this.$emit('get', 0, 600) : this.$emit('get', 0, 300)
      } else {
        this.doubleChart === 1 ? this.$emit('get', window.screen.width, window.screen.height)
          : this.$emit('get', window.screen.width, window.screen.height / 2)
      }
    },
    full () {
      if (this.isFull) {
        this.exitScreen(true)
        this.doubleChart === 1 ? this.$emit('get', 0, 600) : this.$emit('get', 0, 300)
      } else {
        this.fullScreen()
        this.doubleChart === 1 ? this.$emit('get', window.screen.width, window.screen.height)
          : this.$emit('get', window.screen.width, window.screen.height / 2)
      }
    },
    fullScreen () {
      let docElm = document.documentElement
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen()
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen()
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen()
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen()
      }
      this.isFull = true
      this.imgTitle = this.$t('chart.exitScreen')
      this.iconClass = ICON_EXIT_FULL_SCREEN
      this.setTimer()
      document.getElementById(this.wrapperId).classList.add('chart-position')
      document.getElementById(this.wrapperId).style.position = 'fixed'
      document.getElementsByClassName('app-wrapper')[0].classList.add('auto-scroll')
      document.getElementById(this.wrapperId).addEventListener('mousemove', this.setEvent)
    },
    exitScreen (buttonClick) {
      if (buttonClick) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      }
      this.isFull = false
      this.imgTitle = this.$t('chart.fullScreen')
      this.iconClass = ICON_FULL_SCREEN
      this.clearTimer()
      document.getElementById(this.wrapperId).classList.remove('chart-position')
      document.getElementById(this.wrapperId).style.position = 'relative'
      document.getElementsByClassName('app-wrapper')[0].classList.remove('auto-scroll')
      document.getElementById(this.wrapperId).removeEventListener('mousemove', this.setEvent)
    },
    setTimer () {
      if (this.isEnter) return
      this.timer = setInterval(() => {
        if (this.showIcon) {
          this.showIcon = false
        }
        this.showIcon = false
      }, 3000)
    },
    clearTimer () {
      clearInterval(this.timer)
      this.timer = null
    },
    clickEsc () {
      let isFullscreen = document.webkitFullscreenElement || document.mozFullScreenElement
      if (isFullscreen == null) {
        if (this.isFull) {
          this.sendSize()
          this.showIcon = true
          this.exitScreen(false)
        }
      }
    },
    setEvent (e) {
      this.mouseDirection.x = e.screenX
      this.mouseDirection.y = e.screenY
    }
  },
  props: {
    wrapperId: {
      type: String
    },
    fullProps: {
      type: Boolean,
      default: false
    },
    doubleChart: {
      type: Number,
      default: 1
    }
  },
  mounted () {
    this.imgTitle = this.$t('chart.fullScreen')
  },
  created () {
    document.addEventListener('fullscreenchange', () => {
      this.clickEsc()
    })
    document.addEventListener('mozfullscreenchange', () => {
      this.clickEsc()
    })
    document.addEventListener('webkitfullscreenchange', () => {
      this.clickEsc()
    })
    document.addEventListener('msfullscreenchange', () => {
      this.clickEsc()
    })
  },
  watch: {
    mouseDirection: {
      deep: true,
      handler () {
        this.showIcon = true
        this.clearTimer()
        this.setTimer()
      }
    },
    fullProps () {
      if (this.fullProps && this.isFull) {
        this.full()
      }
    }
  }
}
</script>
